export const navConfig = {
  en: {
    home: {
      title: 'Home',
      href: '/en',
    },
    company: {
      title: 'Company',
      subPaths: [
        {
          title: 'About Us',
          href: '/en/about',
          description:
            'Çalışkan Restorasyon Yapı A.Ş. 2014 yılında Kemal ÇALIŞKAN tarafından kurulmuş olup ,Eski eser onarımı başta olmak üzere Üst ve Alt yapı alanlarında hizmet vermekte olan taahhüt firmasıdır',
        },

        {
          title: 'References',
          href: '/en/references',
          description:
            'Çalışkan Restorasyon Yapı A.Ş. 2014 yılında Kemal ÇALIŞKAN tarafından kurulmuş olup ,Eski eser onarımı başta olmak üzere Üst ve Alt yapı alanlarında hizmet vermekte olan taahhüt firmasıdır',
        },
      ],
    },
    Projects: {
      title: 'Projects',
      href: '/en/projects',
    },
    contact: {
      title: 'Contact',
      href: '/en/contact',
    },
  },
  tr: {
    home: {
      title: 'Anasayfa',
      href: '/tr',
    },
    company: {
      title: 'Kurumsal',
      subPaths: [
        {
          title: 'Hakkımızda',
          href: '/tr/about',
          description:
            'Çalışkan Restorasyon Yapı A.Ş. 2014 yılında Kemal ÇALIŞKAN tarafından kurulmuş olup ,Eski eser onarımı başta olmak üzere Üst ve Alt yapı alanlarında hizmet vermekte olan taahhüt firmasıdır',
        },

        {
          title: 'Referanslarımız',
          href: '/tr/references',
          description:
            'Geçmiş projelerimiz ve iş ortaklarımızla edindiği güçlü referanslarla, müşterilerine en iyi hizmeti sunmaktadır',
        },
      ],
    },
    Projects: {
      title: 'Projeler',
      href: '/tr/projects',
    },
    contact: {
      title: 'İletişim',
      href: '/tr/contact',
    },
  },
}
